<template>
  <div class="gray-page">
    <div class="tip-info" v-show="$route.query.id">新模式需等到当前模式剩余时长结束后才生效</div>
    <ModelList
      :school="school"
      :text="deposit_text"
      :list="planList"
      :choice.sync="choice"
    />
    <div class="bottom-tool">
      <div class="title">实付款</div>
      <div class="wechatNumber">￥{{order_amount}}</div>
      <Btn title="去支付" width="2rem" @click="Pay" />
    </div>
  </div>
</template>

<script>
  import ModelList from './components/ModelList'
  export default {
    data () {
      return {
        title: 'aaa',
        school: '',
        plan_text: '',
        deposit_text: '',
        planList: [],
        choice: 0,
        order_amount: 0
      }
    },
    methods: {
      Pay () {
        if (this.$route.query.school_id) {
          if (this.plan_text) {
            this.$ShowConfirm(this.plan_text, { showCancel: false }).then(() => {
              this.PlanBuyPlan()
            })
          } else {
            this.PlanBuyPlan()
          }
        } else if (this.$route.query.id) {
          if (this.plan_text) {
            this.$ShowConfirm(this.plan_text, { showCancel: false }).then(() => {
              this.renewPlan()
            })
          } else {
            this.renewPlan()
          }
        }
        // this.$ShowToast('支付成功', { icon: 'success' })
        // this.$ShowConfirm('您已选购模式，但尚未添加水杯编号，请您尽快到首页添加水杯编号！', { showCancel: false }).then(() => {})
      },
      // 获取继续订购列表
      CupGetPlanByCupId () {
        this.$Get('Common.CupGetPlanByCupId', {
          cup_id: this.$route.query.id
        }).then(res => {
          this.school = res.data.school
          this.plan_text = res.data.plan_text
          this.deposit_text = res.data.deposit_text
          this.planList = res.data.planList
        })
      },
      // 获取学校可购买模式
      PlanGetPlanBySchoolId () {
        this.$Get('Common.PlanGetPlanBySchoolId', {
          school_id: this.$route.query.school_id
        }).then(res => {
          this.school = res.data.school
          this.plan_text = res.data.plan_text || ''
          this.deposit_text = res.data.deposit_text
          this.planList = res.data.planList
        })
      },
      // 继续订购计算
      CupCalRenewPlan () {
        this.$Post('Common.CupCalRenewPlan', {
          plan_id: this.choice,
          cup_id: this.$route.query.id
        }).then(res => {
          this.order_amount = res.data.order_amount
        })
      },
      // 学校可购买模式计算
      PlanCalBuyPlan () {
        this.$Post('Common.PlanCalBuyPlan', {
          plan_id: this.choice
        }, { loading: false }).then(res => {
          this.order_amount = res.data.order_amount
        })
      },
      // 提交继续订购
      renewPlan () {
        this.$Post('Common.CupRenewPlan', {
          plan_id: this.choice,
          cup_id: this.$route.query.id,
          url: location.origin + location.pathname + '#/Common/Home'
        }).then(res => {
          // this.$ShowToast('支付成功', { icon: 'success' })
          // this.mockPay(this.$Tool.GetModelName(res.data.url)['order_sn'])
          location.href = res.data.url
        })
      },
      // 提交学校购买
      PlanBuyPlan () {
        this.$Post('Common.PlanBuyPlan', {
          plan_id: this.choice,
          school_id: this.$route.query.school_id,
          url: location.origin + location.pathname + '#/Common/Home'
        }).then(res => {
          // this.$ShowToast('支付成功', { icon: 'success' })
          // this.mockPay(this.$Tool.GetModelName(res.data.url)['order_sn'])
          location.href = res.data.url
        })
      }
      // 模拟支付
      // mockPay (orderSn) {
      //   /* eslint-disable */
      //   this.$Post('Common.mockPay', {
      //     order_sn : orderSn
      //   }).then(res => {
      //     this.$ShowToast('支付成功', { icon: 'success' }).then(() => {
      //       this.$nav('Common.Home')
      //     })
      //   })
      // }
    },
    watch: {
      choice () {
        if (this.$route.query.school_id) {
          this.PlanCalBuyPlan()
        } else if (this.$route.query.id) {
          this.CupCalRenewPlan()
        }
      }
    },
    created () {
      if (this.$route.query.school_id) {
        this.PlanGetPlanBySchoolId()
        document.title = '选购模式'
      } else if (this.$route.query.id) {
        this.CupGetPlanByCupId()
        document.title = '模式选择'
      }
    },
    components: {
      ModelList
    }
  }
</script>

<style lang="less" scoped>
  .tip-info {
    .p(.24rem .6rem);
    .bg(#fffbee);
    .c(#fd9e0c);
    .fz(.26rem);
  }
  .bottom-tool {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .h(1.1rem);
    .bg(#fff);
    .p(0 .24rem);
    display: flex;
    align-items: center;
    .title {
      .fz(.3rem);
      .c(#333);
      .mr(.2rem);
    }
    .wechatNumber {
      .c(#ff2c4c);
      .fz(.32rem);
      .mr(auto);
    }
  }
</style>
